import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-schedule",
  "use": "icon-schedule-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"icon-schedule\"><path d=\"M29,3 L37,3 L37,39 L3,39 L3,3 L11,3 L11,1 L14,1 L14,3 L26,3 L26,1 L29,1 L29,3 Z M29,6 L29,8 L26,8 L26,6 L14,6 L14,8 L11,8 L11,6 L6,6 L6,36 L34,36 L34,6 L29,6 Z M11,14 L29,14 L29,17 L11,17 L11,14 Z M11,20 L25,20 L25,23 L11,23 L11,20 Z M11,26 L22,26 L22,29 L11,29 L11,26 Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/schedule.svg
// module id = pTDq
// module chunks = 28